import React, { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Categories from "@/components/Categories";
import HowItWorks from "@/components/HowItWorks";
import EnquirySection from "@/components/EnquirySection";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { scrollToId } from "@/config";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 48, fontFamily: "sans-serif" }}>
          Something went wrong. Refresh the page to try again.
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => {
  const [category, setCategory] = useState("Flights");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  const pickCategory = (key) => {
    setCategory(key);
    scrollToId("get-started");
  };

  return (
    <div className="grain min-h-screen bg-ivory text-ink" data-testid="naditra-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Categories onPick={pickCategory} />
        <HowItWorks />
        <EnquirySection category={category} setCategory={setCategory} />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <Home />
    </ErrorBoundary>
  );
}

export default App;
